exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.toggleBtn[data-v-aa268904] {\n  width: 100%;\n  padding: 16px 20px;\n  border: 2px solid #2f4286;\n  background: white;\n  font-size: 16px;\n  line-height: 19px;\n  font-weight: bold;\n  color: #2f4286;\n}\n", ""]);

// exports
